import {
  AppListSortKeys,
  ConnectorFilterKeys,
  TaskListSortKeys,
  WorkflowListSortKeys,
} from '@/common/constants';
import { SelectOptionDto } from '@/common/dto/common/SelectOptionDto/SelectOptionDto';
import { ISelectOption } from '@/common/interface';
import { IResource } from '@/resources/interface';

export function buildWorkflowListSortOptions(resource: IResource): ISelectOption[] {
  return [
    new SelectOptionDto(resource.alphabetically, WorkflowListSortKeys.Name),
    new SelectOptionDto(resource.newest, WorkflowListSortKeys.CreatedDate),
  ];
}

export function buildTaskListSortOptions(resource: IResource): ISelectOption[] {
  return [
    new SelectOptionDto(resource.status, TaskListSortKeys.Status),
    new SelectOptionDto(resource.name, TaskListSortKeys.Name),
  ];
}

export function buildAppListSortOptions(resource: IResource): ISelectOption[] {
  return [
    new SelectOptionDto(resource.alphabetically, AppListSortKeys.Name),
    new SelectOptionDto(resource.newest, AppListSortKeys.DateAdded),
  ];
}

export function buildConnectorFilterOptionsOptions(resource: IResource): ISelectOption[] {
  return [new SelectOptionDto(resource.all, ConnectorFilterKeys.All)];
}
